import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faTriangleExclamation,
  faBellRing,
  faClockRotateLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { MedEventStatusEnum } from '../../../../../../generated';
import {
  dimGrey,
  lightBlack,
  orange,
  successBg,
} from '../../../../../../mainTheme';

export enum Status {
  MISSED = 'MISSED',
  COMPLETE = 'COMPLETE',
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
}

export enum AdherenceStatus {
  MISSED = 'Missed',
  PAST_DUE = 'Past due',
  UNKNOWN = 'Unknown',
}

export const mapApiStatusToEnum = (status: string): Status => {
  // Map normalized MedEventStatusEnum to UI Status enum
  switch (status) {
    case MedEventStatusEnum.COMPLETE:
      return Status.COMPLETE;
    case MedEventStatusEnum.MISSED:
      return Status.MISSED;
    case MedEventStatusEnum.UPCOMING:
      return Status.UPCOMING;
    case MedEventStatusEnum.ACTIVE:
      return Status.ACTIVE;
    default:
      return Status.UPCOMING;
  }
};

export const getStatusColor = (status: string) => {
  const mappedStatus = mapApiStatusToEnum(status);

  switch (mappedStatus) {
    case Status.COMPLETE:
      return lightBlack; // Completed/Dispensed status color
    case Status.MISSED:
      return orange; // Missed/Skipped status color
    case Status.ACTIVE:
      return '#1976d2'; // Active status color
    case Status.UPCOMING:
      return dimGrey; // Upcoming/Pending status color
    default:
      return dimGrey;
  }
};

export const getStatusBackgroundColor = (status: string) => {
  const mappedStatus = mapApiStatusToEnum(status);

  switch (mappedStatus) {
    case Status.COMPLETE:
      return successBg; // Completed/Taken background color
    case Status.MISSED:
      return '#FFF4EB'; // Missed/Skipped background color
    case Status.ACTIVE:
      return '#E3F2FD'; // Active background color
    case Status.UPCOMING:
      return '#F6F6F9'; // Upcoming/Scheduled background color
    default:
      return '#F6F6F9';
  }
};

export const getStatusIcon = (status: string) => {
  const mappedStatus = mapApiStatusToEnum(status);

  switch (mappedStatus) {
    case Status.COMPLETE:
      return (
        <FontAwesomeIcon
          icon={faCheckCircle}
          style={{
            fontSize: 14,
            color: '#41AF60',
          }}
        />
      );
    case Status.MISSED:
      return (
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          style={{
            fontSize: 14,
            color: orange,
          }}
        />
      );
    case Status.ACTIVE:
      return (
        <FontAwesomeIcon
          icon={faBellRing}
          style={{
            fontSize: 14,
            color: '#1976d2',
          }}
        />
      );
    case Status.UPCOMING:
      return (
        <FontAwesomeIcon
          icon={faClockRotateLeft}
          style={{
            fontSize: 14,
            color: '#9999A3',
          }}
        />
      );
    default:
      return null;
  }
};

export const getStatusLabel = (status: string) => {
  const mappedStatus = mapApiStatusToEnum(status);

  switch (mappedStatus) {
    case Status.COMPLETE:
      return 'Completed';
    case Status.MISSED:
      return 'Missed';
    case Status.ACTIVE:
      return 'Active';
    case Status.UPCOMING:
      return 'Upcoming';
    default:
      return 'Scheduled';
  }
};
